import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { TrendingNewsTitle } from "../../../../Constants/Constants";
import { H6, Image, LI, UL } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import { TrendingNewsData } from "../../../../Data/General/Dashboard/Default";
import { dynamicImage } from "../../../../Utils";

const TrendingNews = () => {
  return (
    <Col xxl="3" lg="4" sm="6" className="box-col-4">
      <Card className="news-update">
        <DashboardCommonHeader title={TrendingNewsTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <UL className="simple-list">
            {TrendingNewsData.map((item, index) => (
              <LI className="d-flex align-items-center gap-3" key={index}>
                <div className="flex-shrink-0">
                  <Image src={dynamicImage(item.image)} alt="update" />
                </div>
                <div className="flex-grow-1">
                  <Link to={`${process.env.PUBLIC_URL}/applications/users/user-profile`}>
                    <H6>{item.title}</H6>
                  </Link>
                  <span>{item.time}</span>
                </div>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TrendingNews;
